export default {
  /**
   * プロット追加
   *
   * @param state
   * @param payload
   * @constructor
   */
  CREATE: (state, payload) => {
    if(payload) {

      state.plot = payload;
    }
  },
  /**
   * 全データクリア
   *
   * @param state
   * @constructor
   */
  CLEAR: (state) => {
    state.plot = null
  }
}
